import React from "react";
import PageFrame from "./PageFrame";
import PageHeading from "./PageHeading";
import Abs from "./Abs";
import CardIcon from "./CardIcon";

/**
 * Page 07 - Proprietary Database.
 *
 * Four stepped-tone cards across the page (x 102, 313, 538, 750 at y 265..660), a lede
 * at the top left, and a tinted band across the foot at y 721..748.
 *
 * The investor, property and agent counts come from the database. The fourth card,
 * "100% investment-properties-focused", is a statement about the firm rather than a
 * measurement, so it is template content and always prints.
 */

const INVESTMENT_FOCUS = '100%';

const CARDS = [
    {x: 102, w: 199, tone: 1, icon: 'people', iconFill: '#a3ce83', key: 'investors', title: 'INVESTORS',
     desc: ['ACTIVE CAPITAL', 'SOURCES TRACKED', 'ACROSS ASSET', 'CLASSES']},
    {x: 313, w: 209, tone: 2, icon: 'buildings', iconFill: '#8dc263', key: 'properties', title: 'PROPERTIES',
     desc: ['MAPPED COMMERCIAL', 'ASSETS ACROSS U.S.', 'MARKETS']},
    {x: 538, w: 201, tone: 3, icon: 'people', iconFill: '#a3ce83', key: 'agents', title: 'AGENTS',
     desc: ['BROKERS IN OUR', 'CROSS-REFERRAL', 'AND CO-MARKETING', 'NETWORK']},
    {x: 750, w: 200, tone: 4, icon: 'shield', iconFill: '#8dc263', key: 'investmentFocus', title: 'iNVESTMENT PROPERTIES-FOCUSED',
     desc: ['SPECIALIZED', 'INTELLIGENCE ON', 'INVESTMENT SALES +', 'CAPITAL MARKETS']},
];

export default function ProprietaryDatabase({stats, pageNo, totalPages}) {
    return (
        <PageFrame fixed pageNo={pageNo} totalPages={totalPages}>
            <PageHeading
                eyebrow='PROPRIETARY DATABASE'
                title='A Shared Database '
                titleAccent='Across All Offices.'
            />

            <Abs x={48} y={112} w={997} className='bov-rule'/>

            <Abs x={48} y={135} w={520}>
                <div className='bov-db__intro'>
                    Almost four decades of relationships, transactions, and market intelligence -
                    codified into a database that connects every STRIVE listing to a curated
                    audience of qualified buyers, agents, and capital partners.
                </div>
            </Abs>

            {CARDS.map(card => (
                <Abs key={card.key} x={card.x} y={265} w={card.w}>
                    <div className={`bov-db__card bov-db__card--${card.tone}`}>
                        <CardIcon name={card.icon} fill={card.iconFill}/>
                        <div style={{marginTop: '145px'}}>
                            <div className='bov-db__value'>
                                {splitSuffix(card.key === 'investmentFocus'
                                    ? INVESTMENT_FOCUS
                                    : stats[card.key])}
                            </div>
                            <div className='bov-db__title'>{card.title}</div>
                            <div className='bov-db__desc'>
                                {card.desc.map((line, i) => <div key={i}>{line}</div>)}
                            </div>
                        </div>
                    </div>
                </Abs>
            ))}

            <Abs x={48} y={721} w={960}>
                <div className='bov-db__band'>
                    <div className='bov-db__bandLeft'>CONTINUOUSLY UPDATED</div>
                    <div className='bov-db__bandRight'>
                        Daily refresh of investor activity  •  Weekly property market scans  •
                        Monthly relationship audits
                    </div>
                </div>
            </Abs>
        </PageFrame>
    );
}

/** The template picks the separator or suffix out in green ("109,562", "22,700+"). */
function splitSuffix(value) {
    const text = String(value);
    const suffix = /^([\d.,\s]*?)([%+]+)$/.exec(text);
    if (suffix) return <span>{suffix[1]}<em>{suffix[2]}</em></span>;
    if (text.indexOf(',') === -1) return text;
    const parts = text.split(',');
    return (
        <span>
            {parts.map((part, i) => (
                <span key={i}>{i ? <em>,</em> : null}{part}</span>
            ))}
        </span>
    );
}
